define('v3/Common/Services/extraInstructionService',[
	'jquery',
	'lodash',
	'module',
	'v3/Common/Services/Backend/extraInstructionBackend'
],
function ($,
	_,
	module,
	extraInstructionBackend
) {
	return {
		startExtraInstruction: function (subjectGroupId, extraInstructionLessonId, pupilsForExtraInstruction) {
			var url = module.config().actions.goToLesson;
			window.location.href = url + '#lessonid=' + extraInstructionLessonId + '&subjectGroupId=' + subjectGroupId + '&pupilsForExtraInstruction=' + pupilsForExtraInstruction;
		},
		addExtraInstructionForPupil: function (pupilId, subjectGroupId, learningObjectiveId) {
			return extraInstructionBackend.addExtraInstructionForPupil(pupilId, subjectGroupId, learningObjectiveId);
		}
	};
});
